import { SiloLogoIcon } from "../../icons";
import { cn } from "../../utils/class-names";

interface MainLogoProps {
  className?: string;
}

export function MainLogo({ className }: MainLogoProps): JSX.Element {
  return <SiloLogoIcon className={cn("text-white h-9", className)} />;
}
